export const FETCHING_AMBASSADOR_AUDIENCE = 'FETCHING_AMBASSADOR_AUDIENCE'
export const RECEIVED_AMBASSADOR_AUDIENCE = 'RECEIVED_AMBASSADOR_AUDIENCE'
export const ERROR_FETCHING_AMBASSADOR_AUDIENCE =
  'ERROR_FETCHING_AMBASSADOR_AUDIENCE'
